export const contactInfo = {
  /** 內政部立案的正式名稱 */
  legalName: "台灣AI應用推廣協會",
  /** 立案字號 */
  registration: "內政部合法立案社會團體（台內團字第 1150024480 號）",
  address: "臺南市北區西華街57號5樓",
  email: "2026taiaa@gmail.com",
  /** 協會 LINE 社群邀請連結（reurl 短網址，由協會自行維護指向） */
  communityUrl: "https://reurl.cc/LenV34",
  /** Google Maps 嵌入網址（免 API key）。pb 參數中的 1z... 是「台南市北區西華街57號5樓」的 base64 編碼，6i17 為縮放層級 */
  mapEmbedUrl:
    "https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1z5Y-w5Y2X5biC5YyX5Y2A6KW_6I-v6KGXNTfomZ815qiT!6i17",
};

export interface SocialLink {
  name: string;
  handle: string;
  description: string;
  icon: string;
  color: string;
  /** 尚未開通的官方帳號設為 null，畫面會顯示「建置中」 */
  url: string | null;
}

export const socialLinks: SocialLink[] = [
  {
    name: "LINE 社群",
    handle: "TAIAA 協會社群",
    description: "加入協會 LINE 社群，即時接收活動通知、交流訊息與最新動態",
    icon: "ri-chat-1-fill",
    color: "bg-[#06C755]",
    url: contactInfo.communityUrl,
  },
  {
    name: "Facebook",
    handle: "官方帳號建置中",
    description: "協會粉絲專頁籌備中，開通後將於此公布",
    icon: "ri-facebook-circle-fill",
    color: "bg-[#1877F2]",
    url: null,
  },
  {
    name: "LinkedIn",
    handle: "官方帳號建置中",
    description: "協會 LinkedIn 專頁籌備中，開通後將於此公布",
    icon: "ri-linkedin-box-fill",
    color: "bg-[#0A66C2]",
    url: null,
  },
  {
    name: "YouTube",
    handle: "官方帳號建置中",
    description: "協會影音頻道籌備中，開通後將於此公布",
    icon: "ri-youtube-fill",
    color: "bg-[#FF0000]",
    url: null,
  },
];

export const supportWays = [
  {
    title: "成為會員",
    description:
      "成為 TAIAA 正式會員，以年費支持協會運作，同時享有活動優先報名、會員專屬講座、產業報告等完整權益。",
    icon: "ri-vip-crown-line",
    action: "了解入會方式",
    actionPath: "/membership#join",
  },
  {
    title: "志工參與",
    description:
      "貢獻您的專業與時間，協助活動籌備、內容產製或社群經營。志工可優先參與各項活動並累積人脈資源。",
    icon: "ri-service-line",
    action: "了解志工計畫",
    actionPath: "/membership",
  },
  {
    title: "企業贊助",
    description:
      "以企業名義贊助協會活動或專案，提升品牌曝光、接觸高品質產業人脈，並展現企業社會責任。",
    icon: "ri-building-4-line",
    action: "洽談合作",
    actionPath: "/contact",
  },
  {
    title: "分享擴散",
    description:
      "追蹤我們的社群帳號，分享協會活動與文章。每一次轉發都是對 AI 應用推廣最有力的支持。",
    icon: "ri-share-forward-line",
    action: "關注社群",
    actionPath: "#social-media",
  },
];

export const contactFAQs = [
  {
    question: "一般問題多久會收到回覆？",
    answer:
      "我們會在工作日 24 小時內回覆一般諮詢。若為活動報名或會員相關問題，通常當日即可收到回覆。",
  },
  {
    question: "協會有實體辦公室可以拜訪嗎？",
    answer:
      "協會會址位於臺南市北區西華街57號5樓。建議來訪前先以電子郵件預約，以便安排接待。",
  },
  {
    question: "如何申請演講或合作邀約？",
    answer:
      "請在聯絡表單中選擇「企業合作與贊助」或「活動報名與合作」類型，並詳述您的需求，我們的專案窗口將與您進一步聯繫。",
  },
  {
    question: "媒體採訪該如何聯繫？",
    answer:
      "請選擇「媒體採訪」類型，或直接來信 2026taiaa@gmail.com，我們將安排發言人與您聯繫。",
  },
];